module.exports = __webpack_public_path__ + "img/company.c648b6c7.svg";